import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=63fea0cb&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"
import "./Calculator.vue?vue&type=style&index=0&id=63fea0cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fea0cb",
  null
  
)

export default component.exports